import type { Vector3 } from 'three';

enum EControlsOperation {
    PAN = 'PAN',
    ROTATE = 'ROTATE',
    ZOOM = 'ZOOM',
}

type TControlMouse = 'WHEEL' | 0 | 1 | 2;

enum EControlKey {
    CTRL = 'CTRL',
    SHIFT = 'SHIFT',
}

interface ICameraControls {
    addEventListener(arg0: string, arg1: () => void): unknown;
    addMouseAction(operation: EControlsOperation, mouse: TControlMouse, key?: EControlKey): void;
    dampingFactor: number;
    dispose(): void;
    domElement: HTMLElement | null;
    enableDamping: boolean;
    enablePan: boolean;
    enableRotate: boolean;
    enableZoom: boolean;
    maxDistance: number;
    minDistance: number;
    panSpeed: number;
    removeEventListener(arg0: string, arg1: () => void): unknown;
    removeMouseAction(mouse: TControlMouse, key?: EControlKey): boolean;
    rotateSpeed: number;
    target: Vector3;
    update(): unknown;
    zoomSpeed: number;
}

export { EControlKey, EControlsOperation };

export type { ICameraControls, TControlMouse };
